module.exports = __webpack_public_path__ + "static/media/hero-services.68cb72df.jpg";